import React, { useState, useEffect } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import ContentNotification from "./components/ContentNotification";
import NewsContent from "./components/NewsContent";
import ContentList from "./components/ContentList";
import { getNotiList } from "../../reducers/companyContentManage"
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { formatDate, parseTags } from "../../utils/format";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import { useLocation } from "react-router-dom";
import Copyright from "../../components/Copyright";

const contentList: any = [];

const CompanyContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {
    loading,
    success,
    error,
    notiList,
  } = useSelector((state: any) => state.companyContentManage);

  useEffect(() => {
    const data = "";
    dispatch(getNotiList(data));
  }, [dispatch]);

  const contentNotiList = notiList.map((item: any) => ({
    title: item.title,
    type: {
      name: item.type,
      label: item.type == "news" ? "ニュース" : "求人情報",
    },
    tags: item.tags ? parseTags(String(item.tags)) : "", // ["正社員", "タレント限定"]
    date: formatDate(item.public_date),  // "2024年 10月4日"
    action: () => {
      if(item.type === "news"){
        navigate("/company/news/detail/" + item.id);
        return;
      }
      navigate(item.is_public ? "/company/job/detail/" + item.id : "/company/job/preview/" + item.id);
    },
  }))

  const location = useLocation();
  const successMsg = location.state?.successMsg;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(() => {
    if(successMsg) {
      enqueueSnackbar("I love snacks.", {
        content: (key) => (
          <CustomToast
            title={"メッセージ"}
            message={successMsg}
            variant={"success"}
            snackbarKey={key}
            closeSnackbar={closeSnackbar}
          />
        ),
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [successMsg]);
  
  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="mb-10">
            <ContentNotification contentList={contentNotiList} />
          </div>
          <div className="mb-6">
            <NewsContent />
          </div>
          <div>
            <ContentList list={contentList} />
          </div>
        </div>
      </div>
      <Copyright view="company" />
    </>
  );
};

export default CompanyContent;
